import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Global, { fetchProducts, getProductsPriceRange, isValidAccount } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../../util/Loader";
import ProductsComponent from "../../components/Products/ProductsComponent";
import ProductsFilter from "../../components/Products/ProductsComponents";
import { AlertContext } from "../../util/Alerter";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import NotFound from "../../components/NotFound";
import { CurrencyContext, DeliveryCountryContext } from "../../components/Utils";



const MYPRODUCTS_URL = Global.backend + "/index.php/produit/myProducts";
const ENTREPRISE_URL = Global.backend + "/index.php/entreprise/list";


const MyProductList = () => {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const {countries}=useContext(DeliveryCountryContext)

  const [entreprises, setEntreprises] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const [priceRange, setpriceRange] = useState([0, 0]);
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)


  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/user/addproduct", label: "addProduct" })
    setpageTitle("productList")
    setalertTitle(!isValidAccount() && "invisibleProducts")
    setnavLinks([])
  }, [])



  useEffect(() => {
    setisLoading(true)


    axios.all([axios.get(ENTREPRISE_URL),  axios.post(MYPRODUCTS_URL, { userId: localStorage.getItem("id") })])
      .then(axios.spread((entrepriseResponse, myproductsResponse) => {
        setEntreprises(entrepriseResponse.data)

        if (!myproductsResponse.data.length) {
          return
        }

        const productList = fetchProducts(myproductsResponse, false, true)

        setProductList(productList)
        setpriceRange(getProductsPriceRange(productList, currency, getCurrencyPrice))
      })).catch((err) => {
        showAlert("error", t("request.errorFetchProductDetails"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, [])

  useEffect(() => {
    if (isLoading) {
      return
    }

    setpriceRange(getProductsPriceRange(productList, currency, getCurrencyPrice))
  }, [currency, isLoading])



  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !productList.length ? <NotFound /> :
          <>
            <ProductsFilter title={t("navigation2.1")} productList={productList} setFilteredList={setFilteredList} defaultPriceRange={priceRange} entreprises={entreprises} pays={countries} />

            <div className="col-md-9">
              <div className="container-fluid">
                <ProductsComponent itemsPerPage={8} items={filteredList} UserStyle={true} />
              </div>
            </div>
          </>
      )}
    </LoaderComponent>
  );
};

export default MyProductList;